import { API_BASE_URL, getFundingToken, getIpeWorkspaceMode } from './api';

const DEDUP_WINDOW_MS = 5000;
const MAX_RAW_MESSAGE_LEN = 4000;
const MAX_STACK_LEN = 8000;

let lastDedupKey = '';
let lastDedupAt = 0;

function trim(value, maxLen) {
  const s = String(value || '').trim();
  if (!s) return '';
  return s.length <= maxLen ? s : s.slice(0, maxLen);
}

function extractRawErrorMessage(error) {
  if (!error) return '';
  if (typeof error === 'string') return error.trim();
  return (
    error.rawMessage
    || (error.message && String(error.message).trim())
    || (error.response?.data?.error && String(error.response.data.error).trim())
    || (error.response?.data?.message && String(error.response.data.message).trim())
    || String(error).trim()
  );
}

function buildDedupKey(context, rawMessage) {
  return `${String(context || '').trim()}::${trim(rawMessage, 200)}`;
}

/**
 * 将前端错误上报到后台日志（静默、去重、不阻塞 UI）
 */
export function logIpeClientError(context, error, userMessage, extra = undefined) {
  if (process.env.NODE_ENV === 'test') return;

  const rawMessage = trim(extractRawErrorMessage(error), MAX_RAW_MESSAGE_LEN);
  const dedupKey = buildDedupKey(context, rawMessage);
  const now = Date.now();
  if (dedupKey === lastDedupKey && now - lastDedupAt < DEDUP_WINDOW_MS) {
    return;
  }
  lastDedupKey = dedupKey;
  lastDedupAt = now;

  const token = getFundingToken();
  if (!token) return;

  const payload = {
    context: trim(context, 128) || 'unknown',
    rawMessage: rawMessage || undefined,
    userMessage: trim(userMessage, 512) || undefined,
    errorCode: error?.code ? trim(error.code, 64) : undefined,
    httpStatus: Number.isFinite(Number(error?.status)) ? Number(error.status) : undefined,
    pageUrl: typeof window !== 'undefined' ? trim(window.location.href, 512) : undefined,
    stackTrace: error?.stack ? trim(error.stack, MAX_STACK_LEN) : undefined,
    extraJson: extra && typeof extra === 'object' ? trim(JSON.stringify(extra), 2000) : undefined,
  };

  try {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      'X-IPE-Workspace': getIpeWorkspaceMode(),
    };
    fetch(`${API_BASE_URL}/ipe-users/client-error-log`, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}
